export const apiEndpoint = [
  process.env.REACT_APP_API_ENDPOINT,
  process.env.REACT_APP_API_VERSION,
].join('/');
